import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
import { MultiRiskAttibuteModelItem } from '../multi-risk.attribute.model.item';
import { MultiRiskModelItem } from '../multi-risk.model.item';
declare var $: any;

@Component({
    selector: 'app-multi-risk-item',
    templateUrl: './multi-risk-item.component.html',
    styleUrls: ['./multi-risk-item.component.css']
})
export class MultiRiskItemComponent implements OnInit {

    public modelName = '';
    public model: MultiRiskModelItem | any = {};
    public allModelsModel: any;
    public modelDisabled = true;
    public addNewAttributeSubmitted = false;
    public newAttributeForm: FormGroup;


    @Input() modelId = '';
    @Input() outcomes: any[] = [];
    @Input() dataRobotModels: any[] = [];
    @Input() attributes: any[] = [];
    @Input() operators: any[] = [];

    @Output() itemLoaded = new EventEmitter<void>();
    @Output() showErrorMessage = new EventEmitter<string>();
    @Output() getModelList = new EventEmitter<any>();

    public myform: FormGroup = new FormGroup({
        outcomeSelect: new FormControl(),
        dataRobotModelSelect: new FormControl(),
        mrModelPriority: new FormControl(),
        statusSwitch: new FormControl()
    });

    constructor(
        private connectionService: ConnectionService,
        private formBuilder: FormBuilder
    ) {
        this.newAttributeForm = this.formBuilder.group({
            description: ['', Validators.required],
            operator: ['', Validators.required],
            value: ['', Validators.required]
        });
        this.allModelsModel = {
            id: 0, description: 'All Models'
        }
    }

    ngOnInit(): void {
        this.disableFields();
        this.getModelDetailAux(this.modelId).then(
            () => this.itemLoaded.emit()
        );
    }

    onChangeOutcome() {
        const promise = new Promise((resolve, reject) => {
            const postData: any = {
                outcomeId: this.myform.controls.outcomeSelect.value.id,
                id: Number(this.modelId)
            };
            this.connectionService.postRequest(environment.gateway + 'model/outcome', postData, 'application/json').subscribe(
                (data: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    resolve(data);
                },
                (error: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    this.showErrorMessage.emit(error.error.msg);
                    reject(error);
                }
            );
        });
        return promise;
    }

    getModelDetailAux(pModelId: string) {
        const promise = new Promise((resolve, reject) => {
            this.getModelDetail(pModelId).then(
                (data: MultiRiskModelItem) => {
                    this.model = data;
                    this.modelName = data.name;
                    data.active ? this.disableFields() : this.enableFields();
                    this.myform.controls.statusSwitch.patchValue(data.active);
                    this.outcomes.forEach(element => {
                        if (element.id === data.outcomeId) {
                            this.myform.controls.outcomeSelect.patchValue(element);
                        }
                    });

                    if (data.outcomeId !== 8 &&
                        this.dataRobotModels.filter((f: any) => f.id === 0 && f.description === 'All Models').length === 0) {
                        this.dataRobotModels.push(this.allModelsModel);
                    }

                    if (data.outcomeId === 8 &&
                        this.dataRobotModels.filter((f: any) => f.id === 0 && f.description === 'All Models').length > 0) {
                        this.dataRobotModels.pop();
                    }

                    this.myform.controls.dataRobotModelSelect.patchValue(null);

                    for (var i = this.dataRobotModels.length - 1; i >= 0; i--) {
                        if (this.dataRobotModels[i].id === data.datarobotModelId) {
                            this.myform.controls.dataRobotModelSelect.patchValue(this.dataRobotModels[i]);
                            break;
                        }
                    }
                    this.myform.controls.mrModelPriority.patchValue(data.priority);
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
        return promise;
    }

    getModelDetail(detailId: string) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'model/detail/' + detailId, 'application/json').subscribe(
                (data: any) => {
                    const multiRiskModel: MultiRiskModelItem = new MultiRiskModelItem(data.object, this.attributes, this.operators, this.dataRobotModels, this.outcomes);
                    resolve(multiRiskModel);
                },
                (error: any) => {
                    this.showErrorMessage.emit(error.error.msg);
                    reject(error);
                }
            );
        });
        return promise;
    }

    disableFields() {
        this.modelDisabled = true;
        this.myform.controls.outcomeSelect.disable();
        this.myform.controls.dataRobotModelSelect.disable();
        this.myform.controls.mrModelPriority.disable();
    }

    enableFields() {
        this.modelDisabled = false;
        this.myform.controls.outcomeSelect.enable();
        this.myform.controls.dataRobotModelSelect.enable();
        this.myform.controls.mrModelPriority.enable();
    }

    onChangeModelStatus() {
        this.disableFields();
        const promise = new Promise((resolve, reject) => {
            const postData: any = {
                active: this.myform.controls.statusSwitch.value,
                id: Number(this.modelId)
            };
            this.connectionService.postRequest(environment.gateway + 'model/status/', postData, 'application/json').subscribe(
                (data: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    resolve(data);
                },
                (error: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    this.showErrorMessage.emit(error.error.msg);
                    reject(error);
                }
            );
        });
        return promise;
    }

    onChangeDataRobotModel() {
        const promise = new Promise((resolve, reject) => {
            const postData: any = {
                datarobotModelId: this.myform.controls.dataRobotModelSelect.value.id,
                id: Number(this.modelId)
            };
            this.connectionService.postRequest(environment.gateway + 'model/dataRobotModel', postData, 'application/json').subscribe(
                (data: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    resolve(data);
                },
                (error: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    this.showErrorMessage.emit(error.error.msg);
                    reject(error);
                }
            );
        });
        return promise;
    }

    onChangePriority() {
        const promise = new Promise((resolve, reject) => {
            const postData: any = {
                priority: this.myform.controls.mrModelPriority.value,
                id: Number(this.modelId)
            };
            this.connectionService.postRequest(environment.gateway + 'model/priority', postData, 'application/json').subscribe(
                (data: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    resolve(data);
                },
                (error: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.getModelList.emit(this.modelId);
                    this.showErrorMessage.emit(error.error.msg);
                    reject(error);
                }
            );
        });
        return promise;
    }

    onRemoveClick(attribute: MultiRiskAttibuteModelItem) {
        if (this.modelDisabled) {
            return;
        } else {
            const promise = new Promise((resolve, reject) => {
                const postUrl = environment.gateway + '/model/remove/' + attribute.modelId + '/' + attribute.id;
                this.connectionService.deleteRequest(postUrl, 'application/json').subscribe(
                    (data: any) => {
                        this.getModelDetailAux(this.modelId);
                        resolve(data);
                    },
                    (error: any) => {
                        this.getModelDetailAux(this.modelId);
                        this.showErrorMessage.emit(error.error.msg);
                        reject(error);
                    }
                );
            });
            return promise;
        }
    }

    onCreateNewAttributeSubmit() {
        this.addNewAttributeSubmitted = false;
        this.newAttributeForm.controls.description.setValue('');
        this.newAttributeForm.controls.operator.setValue('');
        this.newAttributeForm.controls.value.setValue('');
        $('#createAttributeModal').modal();
    }

    onCreateClick() {
        this.addNewAttributeSubmitted = true;
        if (this.newAttributeForm.invalid) {
            return;
        }

        $('#createAttributeModal').modal('hide');
        const promise = new Promise((resolve, reject) => {
            const postData: any = {
                modelId: Number(this.modelId),
                dataRobotAttributeId: this.newAttributeForm.controls.description.value.id,
                operatorId: this.newAttributeForm.controls.operator.value.id,
                value: this.newAttributeForm.controls.value.value
            };
            this.connectionService.postRequest(environment.gateway + 'modelattribute', postData, 'application/json').subscribe(
                (data: any) => {
                    this.getModelDetailAux(this.modelId);
                    resolve(data);
                },
                (error: any) => {
                    this.getModelDetailAux(this.modelId);
                    this.showErrorMessage.emit(error.error.msg);
                    reject(error);
                }
            );
        });
        return promise;
    }

}
